import { Directive, Input } from '@angular/core';

@Directive()
export class LabelValueBaseComponent {
  @Input() label: string;
  @Input() value: string;
  @Input() labelClassName = 'label';
  @Input() valueClassName = 'value';
}
